module.exports = __webpack_public_path__ + "img/acms-wiki.e39dd899.svg";